var _defs, _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8GasMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "4aGWMpEKkEFoV0dF~7tVZd",
    cx: 23.918,
    cy: 37.014,
    r: 8.939,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 139",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "4aGWMpEKkEFoV0dF~7tVZa",
    cx: 17.5,
    cy: 21.5,
    r: 5.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "4aGWMpEKkEFoV0dF~7tVZb",
    cx: 17.5,
    cy: 21.5,
    r: 7.5,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 136",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#f0f1f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678,
    stopColor: "#d9dcdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2c8cc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "4aGWMpEKkEFoV0dF~7tVZe",
    cx: 30.5,
    cy: 21.5,
    r: 5.5,
    xlinkHref: "#4aGWMpEKkEFoV0dF~7tVZa"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "4aGWMpEKkEFoV0dF~7tVZf",
    cx: 30.5,
    cy: 21.5,
    r: 7.589,
    xlinkHref: "#4aGWMpEKkEFoV0dF~7tVZb"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "4aGWMpEKkEFoV0dF~7tVZc",
    x1: 16.304,
    x2: 36.205,
    y1: 2.148,
    y2: 56.826,
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442\\u043D\\u043E\\u0439 \\u0437\\u0430\\u043B 3",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ea2e4"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0370c8",
    d: "M36,19h2a1,1,0,0,1,1,1v3a1,1,0,0,1-1,1H36a0,0,0,0,1,0,0V19A0,0,0,0,1,36,19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0370c8",
    d: "M10,19h2a0,0,0,0,1,0,0v5a0,0,0,0,1,0,0H10a1,1,0,0,1-1-1V20A1,1,0,0,1,10,19Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#4aGWMpEKkEFoV0dF~7tVZc)",
    d: "M24,3h0A13,13,0,0,1,37,16V32a5,5,0,0,1-5,5H16a5,5,0,0,1-5-5V16A13,13,0,0,1,24,3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#4aGWMpEKkEFoV0dF~7tVZd)",
    d: "M24,3h0A13,13,0,0,1,37,16V32a5,5,0,0,1-5,5H16a5,5,0,0,1-5-5V16A13,13,0,0,1,24,3Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 37,
    r: 8,
    fill: "#0370c8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 21.5,
    r: 5.5,
    fill: "url(#4aGWMpEKkEFoV0dF~7tVZa)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 21.5,
    r: 4.5,
    fill: "url(#4aGWMpEKkEFoV0dF~7tVZb)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 21.5,
    r: 5.5,
    fill: "url(#4aGWMpEKkEFoV0dF~7tVZe)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 21.5,
    r: 4.5,
    fill: "url(#4aGWMpEKkEFoV0dF~7tVZf)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 32,
    r: 1,
    fill: "#343434"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.465,
    cy: 33.464,
    r: 1,
    fill: "#343434"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.001,
    cy: 36.999,
    r: 1,
    fill: "#343434"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.465,
    cy: 40.534,
    r: 1,
    fill: "#343434"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 41.998,
    r: 1,
    fill: "#343434"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.535,
    cy: 40.534,
    r: 1,
    fill: "#343434"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.999,
    cy: 36.999,
    r: 1,
    fill: "#343434"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.535,
    cy: 33.464,
    r: 1,
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8GasMask);
export default __webpack_public_path__ + "static/media/icons8-gas-mask.48c57b65f1f5359d439ff2075502d06f.svg";
export { ForwardRef as ReactComponent };